import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

// Components
import {
  IconCheckCircle,
  IconTimesCircle,
  IconInfoCircle,
} from 'src/Components/shared/Icon'
import { Text } from 'src/Components'

// Styles
import styles from './Bullet.module.scss'

const getVariantAndCount = ({ color, icon }) => {
  if (color) {
    return {
      variant: color,
      variantCount: '500',
    }
  }

  switch (icon) {
    case IconCheckCircle:
      return {
        variant: 'success',
        variantCount: '700',
      }

    case IconTimesCircle:
      return {
        variant: 'danger',
        variantCount: '600',
      }

    case IconInfoCircle:
      return {
        variant: 'warning',
        variantCount: '600',
      }

    default:
      return {
        variant: 'neutralCool',
        variantCount: '900',
      }
  }
}

const Bullet = ({ refiMessage, values }) => {
  const { variant, variantCount } = getVariantAndCount(refiMessage)

  return (
    <Text
      className={styles.bullet}
      variant='neutralCool'
      variantCount='700'
      size='s'
    >
      <Text element='span' variant={variant} variantCount={variantCount}>
        {React.createElement(refiMessage.icon)}
      </Text>
      <FormattedMessage {...refiMessage} values={values} />
    </Text>
  )
}

Bullet.propTypes = {
  refiMessage: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
    icon: PropTypes.func,
  }),
  values: PropTypes.object,
}

export default Bullet
